<template>
	<main class="painel-container">
		<div class="painel-header">
			<h1>Painéis de dados estatísticos de nascimentos</h1>
		</div>
		<div class="painel-content">
			<transition>
				<div class="painel-content__cards">
					<ServiceCard
						v-for="(card, index) in nascimentosCards"
						:key="index"
						:iconType="card.icon"
						:title="card.title"
						:description="card.description"
						:id="card.id"
						:route="card.route"
					/>
				</div>
			</transition>
			<button
				class="btn-voltar mt-5"
				@click="returnToHome"
				>
				Voltar
			</button>
		</div>
	</main>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const route = useRoute();
const router = useRouter();

const nascimentosCards = ref([
	{
		title: 'Nascimentos',
		description: '',
		icon: 'baby',
		id: '565',
		route: '/nascimentos',
	},
	{
		title: 'Registros Tardios',
		description: '',
		icon: 'late',
		id: '578',
		route: '/registros-tardios',
	},
	{
		title: 'Órfãos',
		description: '',
		icon: 'orphan',
		id: '579',
		route: '/orfaos',
	}
])

function returnToHome() {
    router.push({ path: '/' });
	window.scrollTo(0,0);
}

</script>
<style lang="scss" scoped>
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		font-family: 'Roboto', Arial, Helvetica, sans-serif;
	}

	.painel {

		&-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-top: 110px;
			width: 100%;
		}

		&-header {
			& h1 {
				font-size: 32px;
				line-height: 40px;
				font-weight: 700;
			}

			margin-bottom: 50px;
		}

		&-content {
			display: flex;
			flex-direction: column;
			width: 100vw;
			align-self: center;
			margin: 0 auto;

			&__cards {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				justify-self: center;
				justify-content: start;
				max-width: 1048px;
				margin: 0 auto;
				gap: 16px;
				margin-bottom: 48px;

				@media screen and (max-width: 1280px) {
					justify-content: center;
				}
			}

			&__button {
				width: 136px;
				height: 48px;
				padding: 12px;
				border-radius: 8px;
				border: 1px solid #155F6A;
				background: #FFFFFF;
				font-weight: 700;
				font-size: 16px;
				line-height: 24px;
				color: #155F6A;
				transition: .25s;
				margin-left: 32px;

				&:hover {
					background: #155F6A;
					color: #FFFFFF;
				}
			}
		}
	}

	.btn-voltar {
    width: 136px;
    height: 48px;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #155F6A;
    background: #FFFFFF;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #155F6A;
    transition: .25s;
    margin-left: 32px;
    margin-bottom: 32px;

    &:hover {
		background: #155F6A;
		color: #FFFFFF;
		}
	}

	.v-enter-active,
	.v-leave-active {
		transition: opacity 0.5s ease;
	}

	.v-enter-from,
	.v-leave-to {
		opacity: 0;
	}
</style>
